import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import GlobalReducer from './store/reducers/GlobalReducer';
import LoadingDiv from './components/LoadingDiv';
import SuccessToast from './components/toasts/SuccessToast';
import ErrorToast from './components/toasts/ErrorToast';
import './i18n';

const rootReducer = combineReducers({
  GlobalReducer,
});

let composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
export const store = createStore(rootReducer, composeEnhancers(applyMiddleware(thunk)));

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
      <LoadingDiv></LoadingDiv>
      <SuccessToast></SuccessToast>
      <ErrorToast></ErrorToast>
    </BrowserRouter>
  </Provider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
